// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__TC3kQ","headerScrolled":"Header_headerScrolled__MYo_Z","top":"Header_top__So0oM","bottom":"Header_bottom__YZmgT","logo":"Header_logo__GeIE5"};